import React from 'react';

import Results from '../components/results';
import { DfResultsProvider } from '../context/results/df-results-provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AccordionResults from '../components/accordion-results';
import ProductFilters from '../components/productdetail/product-filters';
import Toast from '../components/toast';
import ActiveFilters from '../components/active-filters';
import ErrorBoundary from '../api/error-boundary';
import { DfCategoriesProvider } from '../context/categories/df-categories-provider';

const client = new QueryClient();

interface DfResultsProps {
  dfProductDom: HTMLElement;
}

export default function DfResults({ dfProductDom }: DfResultsProps): React.ReactElement {
  const prefilter = dfProductDom.dataset.search && JSON.parse(dfProductDom.dataset.search);

  const variants =
    dfProductDom.dataset.filterPanelItems &&
    JSON.parse(dfProductDom.dataset.filterPanelItems).variants;

  return (
    <ErrorBoundary slimError={true}>
      <QueryClientProvider client={client}>
        <DfCategoriesProvider>
          <DfResultsProvider dfProductDom={dfProductDom} productData={{ prefilter, variants }}>
            <Toast />
            <ProductFilters />
            <div className="df-content df-pdp-active-filters">
              <ActiveFilters />
            </div>
            <Results withoutGrid isProductPage>
              <AccordionResults />
            </Results>
          </DfResultsProvider>
        </DfCategoriesProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
